export default "__VITE_ASSET__e42c7ccc__"